import { Box, Button, Grid, styled, Theme, Typography } from '@mui/material';

export const ComponentBulkReplaceContainer = styled(Box)`
  display: flex;
  height: 100vh;
  flex-direction: column;
  padding: 20px 30px;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
`;

export const HeaderTopRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const HeaderTitleSection = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const StyledLocationGroupSortButton = styled(Button)({
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '15px',
  fontWeight: 500,
});

export const MediaContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 196px;
  min-width: 237px;
`;

export const ComponentContainer = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
}));

export const ComponentHeaderSection = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderTopLeftRadius: theme.spacing(1),
  borderTopRightRadius: theme.spacing(1),
  padding: '16px',
}));

export const ComponentHeaderTitle = styled(Typography)(
  ({ theme }: { theme: Theme }) => ({
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.text.primary,
  }),
);

export const ComponentPreviewContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
});

export const ReplaceComponentContainer = styled(ComponentPreviewContainer)({
  gap: '12px',
});

export const ComponentPreviewWrapper = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
}));

export const ComponentName = styled(Typography)(({ theme }) => ({
  wordBreak: 'break-word',
  fontSize: '16px',
  color: theme.palette.text.primary,
  maxWidth: '250px',
}));

export const ExistingComponentName = styled(ComponentName)({
  marginLeft: '12px',
});

export const LoadingContainer = styled('div')(({ theme }) => ({
  height: '200px',
  border: `1px dashed ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledStatus = styled('span')(
  ({
    theme,
    type,
  }: {
    theme: Theme;
    type: 'success' | 'warning' | 'error';
  }) => `
    background-color: transparent;
    color: ${
      type === 'success'
        ? theme.palette.success.main
        : type === 'warning'
        ? theme.palette.warning.main
        : theme.palette.error.main
    };
  `,
);
